'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _adbar = require('redux/modules/adbar');

var adbarActions = _interopRequireWildcard(_adbar);

var _reactCookie = require('react-cookie');

var _storage = require('helpers/storage');

var _storage2 = _interopRequireDefault(_storage);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _Link = require('react-router/lib/Link');

var _Link2 = _interopRequireDefault(_Link);

var _Button = require('components/Button/Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./CookiePolicyBar.scss');
var logoImg = require('./../../assets/logo-dark.png');

var expireMonths = 6;

var CookiePolicyBar = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    hidden: state.adbar.cookieBarHidden
  };
}, (0, _extends3.default)({}, adbarActions)), _dec(_class = (0, _reactCookie.withCookies)(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(CookiePolicyBar, _Component);

  function CookiePolicyBar(props) {
    (0, _classCallCheck3.default)(this, CookiePolicyBar);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CookiePolicyBar.__proto__ || (0, _getPrototypeOf2.default)(CookiePolicyBar)).call(this, props));

    _this.cookies = new _storage2.default(props.cookies);
    return _this;
  }

  (0, _createClass3.default)(CookiePolicyBar, [{
    key: 'hide',
    value: function hide() {
      var hideCookie = this.props.hideCookie;

      var expires = new Date();
      expires.setMonth(expires.getMonth() + expireMonths);
      this.cookies.setAsBoolean({ name: adbarActions.cookieNames.cookieBar, value: true, expires: expires });
      hideCookie();
    }
  }, {
    key: 'render',
    value: function render() {
      var hidden = this.props.hidden;
      var t = this.context.t;

      var isBarHidden = this.cookies.getAsBoolean({ name: adbarActions.cookieNames.cookieBar });

      if (isBarHidden) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(styles.bar, (0, _defineProperty3.default)({}, styles.hidden, hidden)) },
        _react2.default.createElement('img', { src: logoImg, alt: 'logo', className: styles.logo }),
        _react2.default.createElement(
          'div',
          { className: styles.content },
          _react2.default.createElement(
            'p',
            { className: styles.hint },
            t('We use cookies to give you the best experience on our website')
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(_reactI18next.Interpolate, {
              i18nKey: 'By using our website you agree to our use of cookies in accordance with our {{cookiePolicy}}.',
              cookiePolicy: _react2.default.createElement(
                _Link2.default,
                { to: '/info/cookie-policy' },
                t('cookie policy', { context: 'in accordance with our [cookie policy]' })
              )
            })
          )
        ),
        _react2.default.createElement(
          _Button2.default,
          { className: (0, _classnames2.default)('btn-stroke', styles.closer), onClick: this.hide },
          t('Accept')
        )
      );
    }
  }]);
  return CookiePolicyBar;
}(_react.Component), _class3.propTypes = {
  cookies: _propTypes2.default.object,
  hidden: _propTypes2.default.bool,
  hideCookie: _propTypes2.default.func
}, _class3.contextTypes = {
  t: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'hide', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'hide'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = CookiePolicyBar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CookiePolicyBar/CookiePolicyBar.js
// module id = 1980
// module chunks = 1